import React from "react";
import "./RoundedButton.css";

function RoundedButton({ children, variant = "outline", className = "", ...props }) {
  return (
    <div
      role="button"
      tabIndex={0}
      className={`rounded-button rounded-button--${variant} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default RoundedButton;
